import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'
import Marquee from '@/components/landing/marquee'
import { clients } from '@/constants/content'

export const Spark: FC<{ className?: string }> = ({ className }): ReactNode => (
    <svg aria-hidden='true' viewBox='0 0 24 24' className={className}>
        <path
            d='M12 0 L14.2 9.8 L24 12 L14.2 14.2 L12 24 L9.8 14.2 L0 12 L9.8 9.8 Z'
            fill='currentColor'
        />
    </svg>
)

const ClientStrip: FC = (): ReactNode => {
    return (
        <section aria-labelledby='clients-label' className='border-y-2 border-ink bg-paper py-7 sm:py-9'>
            <div className='shell'>
                <h2 id='clients-label' className='eyebrow text-ink/70'>
                    {clients.label}
                </h2>
            </div>

            <Marquee
                label='client names'
                speed={2}
                className='mt-5 sm:mt-6'
                controlClassName='right-4 bg-paper text-ink sm:right-8 lg:right-12'
            >
                <ul className='flex items-center'>
                    {clients.names.map(name => (
                        <Fragment key={name}>
                            <li className='whitespace-nowrap px-5 font-heading text-[2rem] font-extrabold leading-none tracking-[-0.03em] wdth-80 sm:px-8 sm:text-5xl lg:text-6xl'>
                                {name}
                            </li>

                            <li aria-hidden='true' className='px-1'>
                                <Spark className='size-5 text-blaze-deep sm:size-7' />
                            </li>
                        </Fragment>
                    ))}
                </ul>
            </Marquee>
        </section>
    )
}

export default ClientStrip
